export default __webpack_public_path__ + "static/media/check.31f408e5.svg";